module.exports = __webpack_public_path__ + "static/media/TH7.8db2c3cf.jpg";